<template>
  <div class="solutionBox">
    <div class="homeHead">
      <div class="headBox">
        <img src="../../assets/images/image/head/logo.png" class="logo">
        <Header class="header"></Header>
      </div>
    </div>
    <div class="bannerBox" v-if="showSwiper" @mouseenter="isBanner" @mouseleave="notBanner">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in swiperList" :key="index" class="swiper-no-swiping">
          <img :src="item.img">
          <div class="swiperItemCon">
            <div class="swiperItemConHead">{{item.title}}</div>
            <div class="swiperItemConDev">
              <router-link tag="span" to="verification/login">立即申请</router-link>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev" v-show="isBegin"></div>
        <div class="swiper-button-next" slot="button-next" v-show="isBegin"></div>
      </swiper>
    </div>
    <wd-indusry v-if="num==0"></wd-indusry>
    <bank-indusry v-if="num==1"></bank-indusry>
    <manpower-industry v-if="num==2"></manpower-industry>
    <insurance-industry v-if="num==3"></insurance-industry>
    <consume-industry v-if="num==4"></consume-industry>
    <interent-indusry v-if="num==5"></interent-indusry>
    <proper-indusry v-if="num==6"></proper-indusry>
    <travel-indusry v-if="num==7"></travel-indusry>
    <others-industry v-if="num==8"></others-industry>
     <!-- 侧边栏组件 -->
    <Drawer :opens="false"></Drawer>
    <Footer class="homeFoot"></Footer>
  </div>
</template>
<script>
import Header from "./../common/Header.vue";
import Footer from "./../common/Footer.vue";
import Drawer from "./../common/drawer.vue";
import { swiper } from "vue-awesome-swiper";
import wdIndusry from "./solution/wdIndustry.vue";
import bankIndusry from "./solution/bankIndustry.vue";
import insuranceIndustry from "./solution/insuranceIndustry.vue";
import manpowerIndustry from "./solution/manpowerIndustry.vue";
import consumeIndustry from "./solution/consumeIndustry.vue";
import travelIndusry from "./solution/travelIndusry.vue";
import properIndusry from "./solution/properIndusry.vue";
import interentIndusry from "./solution/internetIndusry.vue";
import othersIndustry from "./solution/othersIndustry.vue";

import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      num: 0,
      isBegin:false,
      showSwiper: true,
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //点击分页器的指示点分页器会控制Swiper切换
          renderBullet: function(index, className) {
            var text = "";
            switch (index) {
              case 0:
                text = "网贷行业";
                break;
              case 1:
                text = "银行业";
                break;
              case 2:
                text = "人力资源";
                break;
              case 3:
                text = "保险行业";
                break;
              case 4:
                text = "消费金融";
                break;
              case 5:
                text = "互联网平台";
                break;
              case 6:
                text = "租赁行业";
                break;
              case 7:
                text = "旅游行业";
                break;
              case 8:
                text = "其他行业";
                break;
            }
            return (
              '<li class="' + className + '"><span>' + text + "</span></li>"
            );
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, //修改swiper的父元素时，自动初始化swiper
        on: {
          // 使用es6的箭头函数，使this指向vue对象
          click: () => {
            // 通过$refs获取对应的swiper对象
            let swiper = this.$refs.mySwiper.swiper;
            let i = swiper.activeIndex;
            this.tab(swiper, i);
          }
        }
      },
      swiperList: [
        {
          img: require("../../assets/images/solution/banner_img.png"),
          title: "网贷行业解决方案"
        },
        {
          img: require("../../assets/images/solution/banner02_img.png"),
          title: "银行行业解决方案"
        },
        {
          img: require("../../assets/images/solution/rlzyhy_banner03_img.png"),
          title: "人力资源行业解决方案"
        },
        {
          img: require("../../assets/images/solution/banner03_img.png"),
          title: "保险行业解决方案"
        },
        {
          img: require("../../assets/images/solution/banner05_img.png"),
          title: "消费金融行业解决方案"
        },
        {
          img: require("../../assets/images/solution/hlwpt_banner_img.png"),
          title: "互联网平台行业解决方案"
        },
        {
          img: require("../../assets/images/solution/zlhyjjfa_banner_img.png"),
          title: "租赁行业解决方案"
        },
        {
          img: require("../../assets/images/solution/lyhyjjfa_banner_img.png"),
          title: "旅游行业解决方案"
        },
        {
          img: require("../../assets/images/solution/qthyjjfa_banner_img.png"),
          title: "其他行业解决方案"
        }
      ]
    };
  },
  watch: {
    "$route.query.type"() {
      this.num = this.$route.query.type;
      this.$refs.mySwiper.swiper.slideTo(this.num, 1000, true);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  },
  created() {
    if (this.$route.query.type) {
      this.num = this.$route.query.type;
      this.swiperOption.initialSlide = this.num;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    } else {
      this.num = 0;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  },
  methods: {
    tab(swiper, i) {
      this.num = i;
    },
    isBanner(){
      this.isBegin=true;
    },
    notBanner(){
      this.isBegin=false;
    }
  },
  mounted() {},
  components: {
    Header,
    Footer,
    swiper,
    wdIndusry,
    bankIndusry,
    insuranceIndustry,
    manpowerIndustry,
    consumeIndustry,
    travelIndusry,
    interentIndusry,
    properIndusry,
    othersIndustry,
    Drawer
  }
};
</script>
<style lang="scss">
.solutionBox {
  width: 100%;
  height: 100%;
  .homeHead {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 7777;
    height: 50px;
    .headBox {
      width: 1180px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
    }
    .header {
      z-index: 11;
    }
    .logo {
      vertical-align: middle;
    }
    .optiones {
      margin-top: 0;
    }
  }
  .swiper-container {
    .swiper-button-prev {
      left: 20px;
      background-image: url("../../assets/images/H5/light_nor_img.png");
      background-size: cover;
      width: 34px;
      height: 80px;
    }
    .swiper-button-prev:hover {
      background-image: url("../../assets/images/H5/light_hov_pre_img.png");
      background-size: cover;
    }
    .swiper-button-next {
      right: 20px;
      background-image: url("../../assets/images/H5/right_nor_img.png");
      background-size: cover;
      width: 34px;
      height: 80px;
    }
    .swiper-button-next:hover {
      background-image: url("../../assets/images/H5/right_hov_pre_img.png");
      background-size: cover;
    }
    .swiper-slide {
      position: relative;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      .swiperItemCon {
        position: absolute;
        top: 50%;
        margin-top: -49px;
        left: 10%;
        right: 10%;
        width: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .swiperItemConHead {
          font-size: 32px;
          color: #ffffff;
          letter-spacing: 4px;
        }
        .swiperItemConDev {
          width: 120px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          border: 1px solid #fff;
          color: #fff;
          font-size: 14px;
          margin-top: 20px;
          span {
            cursor: pointer;
          }
        }
        .swiperItemConDev:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: calc(1180px / 9);
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      font-family: "PingFangSC-Medium";
      border-radius: 0;
      background: rgba(255, 255, 255, 0.15);
      opacity: 1;
      margin: 0;
      &:hover{
        background: rgba(0,0,0,.2);
      }
      span {
        border-left: 1px solid rgba(255, 255, 255, 0.4);
        padding: 0 33px;
      }
    }
    .swiper-pagination-bullet:nth-child(2) {
      span {
        padding: 0 41px;
      }
    }
    .swiper-pagination-bullet:nth-child(6) {
      span {
        padding: 0 25px;
      }
    }
    .swiper-pagination-bullet:first-child {
      span {
        border: 0;
      }
    }
    .swiper-pagination-bullet-active {
      background: #b41c2e;
      span {
        border-left: 0;
      }
    }
    .swiper-pagination-bullet-active + .swiper-pagination-bullet {
      span {
        border-left: 0;
      }
    }
  }
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0px;
  }
}
</style>
